
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Redirect, Switch } from 'react-router-dom'
import { translate } from 'react-i18next'
import {withStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ArrowForward from '@material-ui/icons/ArrowForward'
import ProtectedRoute from '../routes/ProtectedRoute'
import TranslationContainer from './translation/TranslationContainer'
import Indicator from '../common/Indicator'
import SessionCompleteNotice from './SessionCompleteNotice'
import {getCookie} from '../../utils'
import * as actions from '../../actionTypes'
import withNavigation from './withNavigationHOC'
import {
  isSessionDisabled,
  willBypassTopThreeFactors,
  willBypassOrderImportance,
  willBypassComparingImportance
} from '../../selectors'

import { SESSION_COMPLETE, SESSION_COMPLETE_ADMIN } from '../../constants'

const styles = theme => ({
  arrowForwardIcon: {
    fontSize: 'inherit',
    margin: 'auto 5px',
    verticalAlign: 'middle'
  },
  
  caseIdContainer: {
    margin: 'auto',
    paddingBottom: 15,
    [theme.breakpoints.down('xs')]: {
      maxWidth: '83.33%' // matches material-ui `xs={10}` grid
    }
  },
  caseId: {
    color: theme.typography.label.color,
    textTransform: 'none'
  },
  caseIdText: {
    fontSize: '1rem',
    textTransform: 'capitalize'
  },
  grayBackground: {
    backgroundColor: '#f5f5f5',
  },
})

class CounselingSessionContainer extends Component {

  state = {hasSession: false}

  componentDidMount() {
    if(this.props.bypassSessionLoadFromCookie) {
      this.setState({hasSession: true})
    } else {
      this.loadSessionFromCookie()
    }
  }

  componentDidUpdate(prevProps) {
    // if we have caseId, we must have the session now
    if(!prevProps.caseId && prevProps.caseId !== this.props.caseId) {
      this.setState({hasSession: true})
    }
  }

  loadSessionFromCookie() {
    const sessionId = getCookie('DcpSessionId')
    if(sessionId) {
      this.props.recallSession(sessionId)
    }
  }

  render() {
    const {classes, pages, isCounselingSessionComplete, isCounselingSessionDisabled, navigator, t} = this.props

    return (
      <div>
        <div className={`${classes.caseIdContainer} ${classes.grayBackground}`}>
          {this.renderCaseIdSegment()}
        </div>
        {isCounselingSessionComplete && (
          <div className={classes.grayBackground}>
            <SessionCompleteNotice>
              {isCounselingSessionDisabled ? t(SESSION_COMPLETE) : t(SESSION_COMPLETE_ADMIN) }
            </SessionCompleteNotice>
          </div>
        )}
        <Indicator isVisible={this.props.showIndicator} message={t(this.props.indicatorMessage)}/>
        {this.state.hasSession && (
          <Switch>
            {pages.map(page => (
              <ProtectedRoute
                component={page.component}
                exact
                grantAccess={true}
                key={page.pathname}
                path={page.pathname}
                passProps={{
                  navigator,
                  routeData: {...page.data},
                  sessionComplete: isCounselingSessionComplete,
                  isCounselingSessionDisabled
                }}
                redirectPath="/"
              />
            ))}
              <ProtectedRoute
                component={TranslationContainer}
                exact
                grantAccess={true}
                path="/session/translation"
                passProps={{
                  navigator,
                  sessionComplete: isCounselingSessionComplete,
                  isCounselingSessionDisabled
                }}
                redirectPath="/"
              />
            <Redirect to="/"/>
          </Switch>
        )}
      </div>
    )
  }

  renderCaseIdSegment() {
    const {caseId, classes, sessionType, t} = this.props
    return (
      <Typography variant="subheading" className={classes.caseIdText}>
        {t(sessionType)}
        <ArrowForward className={classes.arrowForwardIcon}/>
        <span className={classes.caseId}>
          {caseId}
        </span>
      </Typography>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  recallSession(sessionId) {
    const action = {type: actions.SESSION_RECALL_REQUESTED, payload: {sessionId, ignoreLastSavedPage: true}}
    dispatch(action)
  }
})

const mapStateToProps = state => ({
  bypassSessionLoadFromCookie: state.counselingSession.bypassSessionLoadFromCookie,
  caseId: state.counselingSession.counselingSessionData.caseId,
  errors: state.counselingSession.errors,
  isCounselingSessionComplete: state.counselingSession.counselingSessionData.isComplete,
  showIndicator: state.counselingSession.isRequestingSessionSave || state.counselingSession.isRequestingEmail,
  indicatorMessage: state.counselingSession.indicatorMessage,
  isCounselingSessionDisabled: isSessionDisabled(state),
  pages: state.counselingSession.pages,
  sessionType: state.counselingSession.sessionType,
})

const navigationConfig = {
  bypass: {
    comparing_importance: {
      predicate: willBypassComparingImportance
    },
    top_3_factors: {
      predicate: counselingSessionData => willBypassTopThreeFactors(counselingSessionData),
      onBypass: (counselingSessionData, dispatch) => {
        const {factorsOption1, factorsOption2} = counselingSessionData
        const action = {
          type: actions.AUTOPOPULATE_TOP_THREE_FACTORS,
          payload: {
            factors: factorsOption1.concat(factorsOption2)
          }
        }
        dispatch(action)
      }
    },
    order_of_importance: {
      predicate: willBypassOrderImportance
    }
  },
  cleanup(dispatch) {
    const action = {type: actions.SESSION_EXIT}
    dispatch(action)
  },
  lastly: {
    goesTo: '/',
    beforeNavigation(dispatch) {
      const action = {type: actions.MARK_SESSION_COMPLETE}
      dispatch(action)
    }
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNavigation(navigationConfig),
  translate(),
  withStyles(styles),
)(CounselingSessionContainer)


// WEBPACK FOOTER //
// ./src/components/counseling-session/CounselingSessionContainer.js